import { WireCoverType } from 'scenes/common/api/quote/types';

export enum WireMotorExcessType {
  Imposed = 'Imposed',
  Standard = 'Standard',
  Additional = 'Additional',
  Under20 = 'Under20',
  VehicleModification = 'VehicleModification',
  Voluntary = 'Voluntary',
}

export enum WireExcessCode {
  BaseAmt = 'BaseAmt',
  VoluntaryAmt = 'VoluntaryAmt',
  InexperienceExcess = 'InexperienceExcess',
  UnderAgedDriverExcess = 'UnderAgedDriverExcess',
  ExcessForDriverInSpecifiedRange = 'ExcessForDriverInSpecifiedRange',
}

export type WireMotorExcess = {
  id: string;
  type: WireMotorExcessType;
  name: WireCoverType;
  code?: WireExcessCode; // This does not appear to be generated by the API
  selected?: Boolean;
  amount: number;
};
